import React from "react";
import Typography from "@material-ui/core/Typography";
import {
  Avatar,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Collapse,
  CardContent,
} from "@material-ui/core";
import {
  ArrowDropDown,
  ArrowDropUp,
  Bookmark,
  ChatBubble,
  MoreVert,
  Share,
} from "@material-ui/icons";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Popover from "@material-ui/core/Popover";
import { useState,useRef } from "react";
import { Alert } from "@material-ui/lab";
import Swal from 'sweetalert2';
import { useSelector,useDispatch } from "react-redux";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import { FaFacebookSquare, FaLinkedin, FaTwitterSquare, FaWhatsappSquare } from "react-icons/fa";
import {MdContentCopy} from 'react-icons/md'
import { HiOutlineUpload } from "react-icons/hi";
import { setAllContent,setFilteredContent,addProfile } from "../../../redux/actions";

export default React.forwardRef(function PollCard({ data },lastContentElementRef) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [answer, setAnswer] = useState("");
  const [optionSnack,setOptionSnackOpen] = useState(false);
  const answerInputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const id = open ? "simple-popover" : undefined;
  const reduxState = useSelector(state => state)
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(reduxState.allContent.contentBySlug);
  const [option, setOption] = useState("");
  const [totalUsers, setTotalUsers] = useState(() => {
    return data.options && data.options?.reduce((acc,option) => acc + option.optionCount,0);
  })
  
  const updateContent = (response) => {
    let allContent = [].concat(reduxState.allContent.allContent),polls = [].concat(reduxState.allContent.polls),filteredContent = [].concat(reduxState.allContent.filteredContent),currentPoll = data;
        allContent.splice(allContent.indexOf(currentPoll),1,response.poll);
        filteredContent.splice(filteredContent.indexOf(currentPoll),1,response.poll);
        polls.splice(polls.indexOf(currentPoll),1,response.poll);
        dispatch(setAllContent(allContent));
        dispatch(setFilteredContent(filteredContent));
  }

  const chooseOption = (event) => {
    setOption(event.target.value);
    const token = window.localStorage.getItem('token');
    fetch(`https://recruitingmonk-v2.azurewebsites.net/poll/choice/${data._id}`,{
      headers:{'Content-Type':'application/json',
      'Authorization':token
    },
      method:'POST',
      body:JSON.stringify({optionValue:event.target.value,uid:reduxState.info.info.uid})
    }).then(res => res.json())
    .then(res => {
      if(res.success){
        console.log(res)
        updateContent(res)
        handleOptionSnack();
      }
    }).catch(error => console.log(error))
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleSnack = () => {
    setOpen(true);
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleOptionSnack = () => {
    setOptionSnackOpen(true);
  };

  const handleOptionSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOptionSnackOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const copyLinkToClipboard = () => {
    handleSnack();
    const elem = document.createElement('textarea');
    elem.value = `https://recruitingmonk2.azurewebsites.net/polls/${data._id}`;
    document.body.appendChild(elem);
    elem.select();
    console.log(elem)
    elem.setSelectionRange(0, 99999); /* For mobile devices */

    // Copy the text inside the text field 
    navigator.clipboard.writeText(elem.value);
    document.body.removeChild(elem);

    savePollShare("clipboard");
  }

  async function addAnswer(){
    const token = window.localStorage.getItem('token');
    if(!reduxState.authUser.isAuthenticated) {
      return Swal.fire({
        icon: "info",
        title: "Oops..",
        text: "Please SignUp/Login the Platform",
      });
    }
    fetch(`https://recruitingmonk-v2.azurewebsites.net/poll/answer/${data._id}`, {
        method:'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body:JSON.stringify({content:answer,uid:reduxState.info.info.uid})
      }).then(res => res.json())
        .then((res) => {
          if(res.success){
            console.log("answered")
            updateContent(res)
            // dispatch(setAllContent([...reduxState.allContent.posts,...reduxState.allContent.qnas]))
          }
        }).catch(err => {
          alert('cannot answer')
          console.log(err)
        })
        answerInputRef.current.value = '';
  }

  const upvote = (action) => {
    const token = window.localStorage.getItem('token');
    if(!reduxState.authUser.isAuthenticated) {
      return Swal.fire({
        icon: "info",
        title: "Oops..",
        text: "Please SignUp/Login the Platform",
      });
    }
    fetch(`https://recruitingmonk-v2.azurewebsites.net/poll/upvote/${action}/${data._id}`, {
        method:'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body:JSON.stringify({uid:reduxState.info.info.uid})
      }).then(res => res.json())
        .then((res) => {
          if(res.success){
            console.log("toggled Upvote");
            updateContent(res)
            //dispatch(setAllContent([...reduxState.allContent.posts,...reduxState.allContent.qnas]))
          }
        }).catch(err => {
          alert('cannot vote qna')
          console.log(err)
        });
  }

  const downvote = (action) => {
    const token = window.localStorage.getItem('token');
    if(!reduxState.authUser.isAuthenticated) {
      return Swal.fire({
        icon: "info",
        title: "Oops..",
        text: "Please SignUp/Login the Platform",
      });
    }
    fetch(`https://recruitingmonk-v2.azurewebsites.net/poll/downvote/${action}/${data._id}`, {
        method:'POST',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body:JSON.stringify({uid:reduxState.info.info.uid})
      }).then(res => res.json())
        .then((res) => {
          if(res.success){
            console.log("toggled Downvote")
            updateContent(res)
            //dispatch(setAllContent([...reduxState.allContent.posts,...reduxState.allContent.qnas]))
          }
        }).catch(err => {
          alert('cannot vote qna')
          console.log(err)
        });
  }

  const calcProgress = (len,i) => {
    return ((i)*100/len).toFixed(2);
  }

  const saveMyFeed = () => {
    if(!reduxState.authUser.isAuthenticated) {
      return Swal.fire({
        icon: "info",
        title: "Oops..",
        text: "Please SignUp/Login the Platform",
      });
    }

    const token = localStorage.getItem('token');
    fetch(`http://localhost:3001/savefeed`,{
      headers:{
        'Content-Type':'application/json',
        'Authorization':token,
      },
      method:'POST',
      body:JSON.stringify({
        uid:reduxState.info.info.uid,
        id:data._id,
        title:data.question,
        content:"",
        tag:'poll',
      })
    }).then(response => {
      if(response.ok) {
          console.log(response)
          return response;
      }
      else {
          var error = new Error("Error " + response.status + ": " + response.statusText);
          error.response = response;
          throw error;
      }
  }).then(response => response.json())
  .then(response => {
    if(response.success){
      const updatedFeed = reduxState.info.info.feed;
      updatedFeed.unshift(response.feedItem);
      dispatch(addProfile({feed:updatedFeed}))
      console.log("saved feed updated")
    }
    else throw new Error('unable to save feed')
  }).catch((error) => {
    console.log(error);
  })
  }

  const savePollShare = (socialMedia) => {
    const token = localStorage.getItem('token');
    fetch(`http://localhost:3001/poll/share/${data._id}`,{
      headers:{
        'Content-Type':'application/json',
        'Authorization':token,
      },
      method:'POST',
      body:JSON.stringify({
       uid:reduxState.info.info.uid,
       socialMedia,       
      })
    }).then(response => {
      if(response.ok) {
          console.log(response)
          return response;
      }
      else {
          var error = new Error("Error " + response.status + ": " + response.statusText);
          error.response = response;
          throw error;
      }
  }).then(response => response.json())
  .then(response => {
    if(response.success) console.log("share saved successfully");
  }).catch(console.log)
  }

  return (
    <div ref={lastContentElementRef} className="flex flex-col p-2 md:mx-2 mb-5 rounded-xl bg-white shadow-xl md:bg-transparent md:shadow-none glass">
      <div className="flex flex-col mb-2">
        <div className="flex flex-row gap-2 justify-start items-center">
          <Avatar alt={data.name} src={data.avatar} />
          <div className="flex-grow">
            <Typography variant="button" component="p">
            {data.name}
            </Typography>
            <Typography variant="caption" component="p" color="textSecondary">
              @{data.username.split("@")[0]}
            </Typography>
          </div>
          <IconButton onClick={handleClick}>
            <MoreVert />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            style={{ marginTop: "2.4em" }}
          >
            <MenuItem onClick={copyLinkToClipboard}>Copy Link</MenuItem>
            <MenuItem onClick={handleClose}>Unfollow</MenuItem>
            <MenuItem onClick={handleClose}>Report</MenuItem>
          </Menu>
          <Snackbar
            open={open}
            autoHideDuration={2000}
            onClose={handleSnackClose}
          >
            <Alert onClose={handleSnackClose} severity="info">
              Link copied to Clipboard!
            </Alert>
          </Snackbar>
        </div>
      </div>
      <div className="flex flex-row mt-3 px-1">
        <div className="flex flex-col items-center gap-2 mr-2">
          <IconButton onClick={()=> upvote(data.upvotes.find(vote => vote.user === reduxState.info.info.uid)?.user?'remove':'add')}>
            <ArrowDropUp fontSize="large" htmlColor={data.upvotes.find(vote => vote.user === reduxState.info.info.uid)?.user? "#B0343C" : ""} />
          </IconButton>
          <p className="text-lg font-semibold">{data.upvotes.length - data.downvotes.length}</p>
          <IconButton
            onClick={()=> downvote(data.downvotes.find(vote => vote.user === reduxState.info.info.uid)?.user?'remove':'add')}
          >
            <ArrowDropDown fontSize="large" htmlColor={data.downvotes.find(vote => vote.user === reduxState.info.info.uid)?.user? "#B0343C" : ""} />
          </IconButton>
        </div>
        <div className="flex flex-col gap-2">
          <div className="">
            <Typography
              variant="h5"
              color="textPrimary"
              style={{ whiteSpace: "pre-line" }}
              component="p"
            >
              {data.question}
            </Typography>
          </div>
          <div className="my-3">
          {data.options.length &&
            <FormControl component="fieldset" >
              <FormLabel component="legend">Choose your answer</FormLabel>
              <RadioGroup
                aria-label="poll"
                name="poll"
                value={(data.options.find(option => {
                    let filtered = option.votes.filter(vote => vote.toString() === reduxState.info.info.uid);
                    return filtered[0] && filtered[0].toString() === reduxState.info.info.uid;
                    })?.optionValue) || option}
                onChange={chooseOption}
              >
              <div style={{position:'relative'}}>
              {data.options?.map((choice,i) => 
              <div>
                <FormControlLabel
                  value={choice.optionValue}
                  control={<Radio />}
                  label={choice.optionValue}
                />
                {reduxState.authUser.isAuthenticated && 
                (data.options.find(option => {
                    let filtered = option.votes.filter(vote => vote.toString() === reduxState.info.info.uid);
                    return filtered[0] && filtered[0].toString() === reduxState.info.info.uid;
                    })?.optionValue) &&
                <div style={{position:"absolute",top:`${calcProgress(data.options.length,i)}%`,zIndex:'-10'}}>
                  <progress max={Number(totalUsers)} value={Number(choice.optionCount/totalUsers)} style={{height:'30px',backgroundColor:'lightgray'}}></progress>
                  <span style={{position:'absolute'}}>
                    {" "+ Number(choice.optionCount*100/totalUsers).toFixed(2) + "%" }
                  </span>
                </div>
                }
              </div>
                )
              }
              </div>
              </RadioGroup>
            </FormControl>
          }
          </div>
          <div className="">
            <Typography
              variant="body1"
              color="textPrimary"
              style={{ whiteSpace: "pre-line" }}
              component="p"
            >
              {data.desc}
            </Typography>
          </div>
        </div>
      </div>
      <Snackbar
            open={optionSnack}
            autoHideDuration={2000}
            onClose={handleOptionSnackClose}
          >
            <Alert onClose={handleOptionSnackClose} severity="info">
              "{option}" Selected!
            </Alert>
          </Snackbar>
      <Divider />
      <div className="flex flex-row items-center justify-between ">
        <div className="flex flex-row items-center gap-2 mx-2">
          <p
            onClick={handleExpandClick}
            className="font-medium text-lg cursor-pointer"
          >
            {" "}
            <ChatBubble htmlColor="#B0343C" />{data.answers.length + " "}
          </p>
          <IconButton onClick={handleClick2}>
            <Share htmlColor="#B0343C" />
          </IconButton>
          <Popover
            id={id}
            open={Boolean(anchorEl2)}
            anchorEl={anchorEl2}
            onClose={handleClose2}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
          >
            <div className="p-2 gap-4 text-3xl rounded-full flex flex-row items-center px-2" >
              <FacebookShareButton children={<FaFacebookSquare color="#4267B2" />} quote={`${data.question}`} url={`https://recruitingmonk-app.azurewebsites.net/qnas/${data._id}`} onShareWindowClose={() => savePollShare("facebook")}/>
              {/* <LinkedinShareButton children={<FaLinkedin color="#0077b5" />} url={`https://recruitingmonk-app.azurewebsites.net/qnas/${data._id}`} title={`${data.question}`} onShareWindowClose={() => savePollShare("linkedin")} /> */}
              <WhatsappShareButton children={<FaWhatsappSquare color="#25D366" />} url={`https://recruitingmonk-app.azurewebsites.net/qnas/${data._id}`} title={`${data.question}`} onShareWindowClose={() => savePollShare("whatsapp")} />
              <TwitterShareButton children={<FaTwitterSquare color="#1DA1F2" />} url={`https://recruitingmonk-app.azurewebsites.net/qnas/${data._id}`} title={`${data.question}`} onShareWindowClose={() => savePollShare("twitter")} />
              <MdContentCopy color="#1DA1F2" onClick={copyLinkToClipboard} />
            </div>
          </Popover>
        </div>
        <IconButton onClick={(e) => reduxState.info.info.feed?.find(feed => feed.id === data._id)?.id ? e.preventDefault() : saveMyFeed()}>
          <Bookmark htmlColor={reduxState.info.info.feed?.find(feed => feed.id === data._id)?.id ? "#B0343C":""} />
        </IconButton>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <div className="flex flex-col mb-4">
            <div className="flex flex-row items-center justify-between w-full">
              <Avatar
                src={(reduxState.authUser.isAuthenticated && reduxState.info.info.avatar)?reduxState.info.info.avatar:""}
                alt="profile icon"
              />
              <input
                ref={answerInputRef}
                onChange={(e) => setAnswer(e.target.value)}
                className="rounded-lg mx-4 border-2 border-gray-200 bg-gray-200 w-full p-2 text-gray-800"
                placeholder="Something in mind? Jot it down..."
              />
              <div style={{cursor:'pointer',background:'#B0343C'}} onClick={addAnswer} className="flex flex-row items-center rounded-lg p-2 text-lg font-bold text-gray-600 gap-2">
                <HiOutlineUpload color="#fff" />
              </div>
            </div>
          </div>
          <p>{data.answers.length} Answers</p>
          <Divider />
          {data.answers.length?data.answers?.map((cmnt) =>
            <AnswerCard
              data={cmnt}
            />):<p className="w-full text-center text-lg font-bold text-gray-300 my-4">No Answers</p>
          }
        </CardContent>
      </Collapse>
    </div>
  );
})

const getTimePassed = (answerDate) => {
  let timeInMs = (new Date()).getTime() - (new Date(answerDate)).getTime();
  if(timeInMs < 10000){
    return `Just now`;
  }
  if(timeInMs < 60000){
    return `${Math.floor(Number(timeInMs/1000)) < 0?0:Math.floor(Number(timeInMs/1000))} sec ago`;
  }
  if(timeInMs < 3600000)
    return `${Math.floor(Number(timeInMs/60000))} min ago`;
  if(timeInMs < 2*3600000)
    return `${Math.floor(Number(timeInMs/3600000))} hour ago`;
  if(timeInMs < 86400000)
    return `${Math.floor(Number(timeInMs/3600000))} hours ago`
  if(timeInMs < 2*86400000)
    return `${Math.floor(Number(timeInMs/86400000))} day ago`
  if(timeInMs < 2592000000)
    return `${Math.floor(Number(timeInMs/86400000))} days ago`
  if(timeInMs < 2*2592000000)
    return `${Math.floor(Number(timeInMs/2592000000))} month ago`
  if(timeInMs < 31104000000)
    return `${Math.floor(Number(timeInMs/2592000000))} months ago`
  else
    return `${Math.floor(Number(timeInMs/31104000000))} year ago`
}
function AnswerCard({data}) {
  return (
    <div className="flex flex-col gap-2 my-2">
      <div className="flex flex-row items-center gap-4">
        <Avatar alt={data.user} src={data.avatar?data.avatar:''} />
        <div className="flex flex-col ">
          <p className="text-lg">{data.name}</p>
      <p className="text-xs text-gray-600" style={{whiteSpace:'pre-line'}}>{getTimePassed(data.date)}</p>
        </div>
      </div>
      <p className="text-base mb-4">
        {data.content}
      </p>
      <Divider />
    </div>
  );
}

export { AnswerCard };
